let config = {
  locale: require('../locale/zh-CN').default,
  set(options) {
    config = Object.assign({}, config, options);
    listeners.forEach(listener => listener());
  },
  get(key) {
    if (key) {
      return config[key];
    }
    return config;
  },
};

function set(options) {
  config = Object.assign({}, config, options);
  listeners.forEach(listener => listener());
}
function get(key) {
  if (key) {
    return config[key];
  }
  return config;
}
const listeners = [];

function addListener(listener) {
  if (listeners.indexOf(listener) === -1) {
    listeners.push(listener);
  }
}

function removeListener(listener) {
  const index = listeners.indexOf(listener);
  if (index > -1) {
    listeners.splice(index, 1);
  }
}

export const localMixin = {
  mounted() {
    addListener(this.onLocaleChange);
  },

  beforeDestroy() {
    removeListener(this.onLocaleChange);
  },

  methods: {
    t(path = '', placement) {
      if (!path) {
        return '';
      }

      const regx = /\{\s*([\w-]+)\s*\}/g;

      const pathArr = path.split('.');
      let index = 0;
      let pattern = config.get('locale');

      while (typeof pattern === 'object' && pathArr[index]) {
        let key = pathArr[index];
        if (/^\d+$/.test(key)) {
          key = Number(key);
        }
        pattern = pattern[key] || '';
        index += 1;
      }

      // eslint-disable-next-line no-confusing-arrow
      const translated = pattern.replace(regx, (_match, key) => (placement ? placement[key] : ''));

      return translated;
    },
    onLocaleChange() {
      this.$forceUpdate();
    },
  },
};

export default {
  get, set,
};
